// extracted by mini-css-extract-plugin
module.exports = {"skeletonHeader":"ApplicationDetailsSkeleton_skeletonHeader__3rAkh","skeletonTitle":"ApplicationDetailsSkeleton_skeletonTitle__3s5ZP"};